import styled, { css } from "styled-components";
import tw from "twin.macro";

export const StyledExpand = styled.svg`
  ${tw`tw-fill-current tw-w-6 tw-h-6`}
`;

StyledExpand.displayName = "StyledExpand";

export const StyledExpandSingle = styled(StyledExpand)<{ $expanded?: boolean }>`
  ${(props) =>
    !props.$expanded &&
    css`
      transform: rotate(180deg);
    `}
`;

StyledExpandSingle.displayName = "StyledExpandSingle";
